export default __webpack_public_path__ + "static/media/THUGS-BNB.60882352.png";